/**
 * balm-product.js
 * バーム商品ページ専用スクリプト
 *
 * 依存関係: window.balmPage / window.BALM_STOCK / window.BALM_VARIANTS
 *
 * UI フロー:
 *   STEP1: 購入タイプ選択（定期購入 / 単品購入）
 *   STEP2-A: 定期購入プラン固定表示（定期購入選択時）
 *   STEP2-B: 単品数量カウンター（単品購入選択時）
 *   STEP3: 香り選択（WARM / NORMAL / MENTHOL）
 *   STEP4: 金額確認・カートに追加
 *
 * 割引ロジック（単品購入のみ）:
 *   discountCount = Math.floor(qty / 3)
 *   discountAmount = discountCount × 1000
 *   合計 = UNIT_PRICE × qty - discountAmount
 *
 * カートAPI仮実装:
 *   /cart/add.js を使用（単品・定期共通）
 *   TODO: Mikawaya Subscription 連携時に定期購入部分を差し替える
 */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     定数
  ------------------------------------------------------------------ */
  var UNIT_PRICE      = Math.min.apply(null, Object.values(window.BALM_PRICES || { default: 3500 }));
  var SUB_PRICE       = 5400;
  var SUB_QTY         = 2;
  var DISCOUNT_UNIT   = 1000;
  var MIKAWAYA_PLAN_ID = 3948609752;
  var DISCOUNT_CYCLE = 2;

  var SUB_VARIANT_MAP = {
    warm: 51533645381848,
    normal: 51533645414616,
    menthol: 51533645447384
  };

  /* ------------------------------------------------------------------
     香り設定
     variantKey: window.BALM_STOCK / BALM_VARIANTS のキーと一致
  ------------------------------------------------------------------ */
  var SCENT_KEYS = ['warm', 'normal', 'menthol'];

  var SCENT_CONFIG = {
    warm:    { label: 'WARM',    variantKey: 'WARM' },
    normal:  { label: 'NORMAL',  variantKey: 'NORMAL' },
    menthol: { label: 'MENTHOL', variantKey: 'MENTHOL' },
  };

  /* ------------------------------------------------------------------
     状態管理
  ------------------------------------------------------------------ */
  var state = {
    purchaseType: 'subscription',
    qty: 1,
    scentCounts: { warm: 0, normal: 0, menthol: 0 },
  };

  /* ------------------------------------------------------------------
     ヘルパー
  ------------------------------------------------------------------ */
  function getLimit() {
    return state.purchaseType === 'subscription' ? SUB_QTY : state.qty;
  }

  function getTotalScents() {
    return SCENT_KEYS.reduce(function (sum, key) {
      return sum + (state.scentCounts[key] || 0);
    }, 0);
  }

  function getDiscountCount(qty) {
    return Math.floor(qty / DISCOUNT_CYCLE);
  }

  function formatYen(amount) {
    return '<span class="price-currency">¥</span>' + amount.toLocaleString('ja-JP');
  }

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function isInStock(key) {
    var config = SCENT_CONFIG[key];
    if (!window.BALM_STOCK || !config) return true;
    var stock = window.BALM_STOCK[config.variantKey];
    return typeof stock !== 'number' || stock > 0;
  }

  function resetScentCounts() {
    state.scentCounts = { warm: 0, normal: 0, menthol: 0 };
  }

  /** qty変更で上限が下がった場合、超過分を末尾の香りから削る */
  function trimScentCounts() {
    var limit = getLimit();
    var excess = getTotalScents() - limit;
    if (excess <= 0) return;
    for (var i = SCENT_KEYS.length - 1; i >= 0 && excess > 0; i--) {
      var key = SCENT_KEYS[i];
      var cut = Math.min(state.scentCounts[key] || 0, excess);
      state.scentCounts[key] = (state.scentCounts[key] || 0) - cut;
      excess -= cut;
    }
  }

  function showStep(el) {
    if (el) el.style.display = '';
  }

  function hideStep(el) {
    if (el) el.style.display = 'none';
  }

  /* ------------------------------------------------------------------
     STEP 1: 購入タイプ選択
  ------------------------------------------------------------------ */
  function initPurchaseType() {
    var group = document.getElementById('balmPurchaseTypeGroup');
    if (!group) return;

    group.addEventListener('click', function (e) {
      var card = e.target.closest('.balm-radio-card');
      if (!card) return;

      var val = card.dataset.value;
      if (state.purchaseType === val) return;

      state.purchaseType = val;
      resetScentCounts();

      group.querySelectorAll('.balm-radio-card').forEach(function (c) {
        c.classList.toggle('is-active', c.dataset.value === val);
        c.querySelector('input').checked = (c.dataset.value === val);
      });

      if (val === 'subscription') {
        showStep(document.getElementById('balmStep2Sub'));
        hideStep(document.getElementById('balmStep2One'));
      } else {
        hideStep(document.getElementById('balmStep2Sub'));
        showStep(document.getElementById('balmStep2One'));
      }

      renderScentGrid();
      renderQtyPromo();
      renderQtyDiscountBanner();
      renderPrice();
      renderCartState();
    });
  }

  /* ------------------------------------------------------------------
     STEP 2-B: 単品数量カウンター
  ------------------------------------------------------------------ */
  function initQuantity() {
    var minusBtn = document.getElementById('balmQtyMinus');
    var plusBtn  = document.getElementById('balmQtyPlus');
    var input    = document.getElementById('balmQtyInput');
    if (!minusBtn || !plusBtn || !input) return;

    minusBtn.addEventListener('click', function () {
      if (state.qty <= 1) return;
      state.qty--;
      input.value = state.qty;
      minusBtn.disabled = state.qty <= 1;
      trimScentCounts();
      renderScentGrid();
      renderQtyPromo();
      renderQtyDiscountBanner();
      renderPrice();
      renderCartState();
    });

    plusBtn.addEventListener('click', function () {
      state.qty++;
      input.value = state.qty;
      minusBtn.disabled = false;
      renderScentGrid();
      renderQtyPromo();
      renderQtyDiscountBanner();
      renderPrice();
      renderCartState();
    });
  }

  /* ------------------------------------------------------------------
     STEP 2-B: 訴求プロモカード
  ------------------------------------------------------------------ */
  function renderQtyPromo() {
    var el = document.getElementById('balmQtyPromo');
    if (!el) return;

    if (state.purchaseType !== 'one_time') {
      el.style.display = 'none';
      return;
    }

    var qty       = state.qty;
    var cycle     = Math.ceil(qty / DISCOUNT_CYCLE);
    var pos       = ((qty - 1) % DISCOUNT_CYCLE) + 1;
    var remaining = DISCOUNT_CYCLE - pos;

    var html;
    var modifier;

    if (remaining > 0) {
      html     = DISCOUNT_CYCLE + '個購入ごとに '
               + '<span class="balm-qty-promo-amount">' + formatYen(DISCOUNT_UNIT) + '割引</span>'
               + '！あと' + remaining + '個';
      modifier = '';
    } else {
      html     = '<span class="balm-qty-promo-amount">'
               + formatYen(DISCOUNT_UNIT * cycle) + '割引</span> 適用済み';
      modifier = 'balm-qty-promo--done';
    }

    el.innerHTML = html;
    el.className = 'balm-qty-promo' + (modifier ? ' ' + modifier : '');
    el.style.display = '';
  }

  /* ------------------------------------------------------------------
     STEP 2-B: 割引バナー
  ------------------------------------------------------------------ */
  function renderQtyDiscountBanner() {
    var banner = document.getElementById('balmQtyDiscountBanner');
    var label  = document.getElementById('balmQtyDiscountLabel');
    var sub    = document.getElementById('balmQtyDiscountSub');
    if (!banner) return;

    if (state.purchaseType !== 'one_time') {
      banner.style.display = 'none';
      return;
    }

    var discountCount = getDiscountCount(state.qty);
    if (discountCount <= 0) {
      banner.style.display = 'none';
      return;
    }

    banner.style.display = '';
    if (label) label.textContent = discountCount + '回分の割引が適用されます！';
    if (sub)   sub.innerHTML   =
      formatYen(discountCount * DISCOUNT_UNIT) + ' 引き（'
      + DISCOUNT_CYCLE + '個ごとに' + formatYen(DISCOUNT_UNIT) + '割引）';
  }

  /* ------------------------------------------------------------------
     STEP 3: 香りカウンター
  ------------------------------------------------------------------ */
  function initScentGrid() {
    var grid = document.getElementById('balmScentGrid');
    if (!grid) return;

    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('.balm-scent-minus, .balm-scent-plus');
      if (!btn || btn.disabled) return;

      var key   = btn.dataset.scentKey;
      var delta = btn.classList.contains('balm-scent-plus') ? 1 : -1;
      var count = state.scentCounts[key] || 0;

      if (delta === 1) {
        if (getTotalScents() >= getLimit()) return;
        if (!isInStock(key)) return;
        state.scentCounts[key] = count + 1;
      } else {
        if (count <= 0) return;
        state.scentCounts[key] = count - 1;
      }

      renderScentGrid();
      renderPrice();
      renderCartState();
    });
  }

  function renderScentGrid() {
    var limit       = getLimit();
    var total       = getTotalScents();
    var limitReached = total >= limit;

    // カウンター表示
    var selEl = document.getElementById('balmScentSelected');
    var totEl = document.getElementById('balmScentTotal');
    if (selEl) selEl.textContent = total;
    if (totEl) totEl.textContent = limit;

    // 各香りカード更新
    SCENT_KEYS.forEach(function (key) {
      var count    = state.scentCounts[key] || 0;
      var inStock  = isInStock(key);
      var card     = document.querySelector('.balm-scent-card[data-scent="' + key + '"]');
      var countEl  = document.getElementById('balmCount' + capitalize(key));
      if (!card) return;

      var minusBtn   = card.querySelector('.balm-scent-minus');
      var plusBtn    = card.querySelector('.balm-scent-plus');
      var stockBadge = card.querySelector('.balm-scent-stock');

      if (countEl) countEl.textContent = count;

      if (!inStock) {
        card.classList.add('is-soldout');
        card.classList.remove('is-selected', 'is-disabled');
        if (stockBadge) stockBadge.style.display = '';
        if (minusBtn)   minusBtn.disabled = true;
        if (plusBtn)    plusBtn.disabled  = true;
      } else {
        card.classList.remove('is-soldout');
        if (stockBadge) stockBadge.style.display = 'none';
        card.classList.toggle('is-selected', count > 0);
        card.classList.toggle('is-disabled', limitReached && count === 0);
        if (minusBtn) minusBtn.disabled = count <= 0;
        if (plusBtn)  plusBtn.disabled  = limitReached;
      }
    });

    // 残り選択数メッセージ
    var remainingEl = document.getElementById('balmScentRemaining');
    if (remainingEl) {
      var remaining = limit - total;
      if (remaining > 0) {
        remainingEl.textContent = 'あと' + remaining + '個選択できます';
        remainingEl.style.display = '';
      } else {
        remainingEl.style.display = 'none';
      }
    }
  }

  /* ------------------------------------------------------------------
     STEP 4: 金額表示
  ------------------------------------------------------------------ */
  function renderPrice() {
    var elTotal       = document.getElementById('balmPriceTotal');
    var elOrigRow     = document.getElementById('balmPriceOriginalRow');
    var elOrig        = document.getElementById('balmPriceOriginal');
    var elDiscRow     = document.getElementById('balmPriceDiscountRow');
    var elDiscLabel   = document.getElementById('balmDiscountCountText');
    var elDisc        = document.getElementById('balmPriceDiscount');
    var elUnitWrap    = document.getElementById('balmUnitPrice');
    var elUnitVal     = document.getElementById('balmUnitPriceVal');
    if (!elTotal) return;

    if (state.purchaseType === 'subscription') {
      elTotal.innerHTML = formatYen(SUB_PRICE);
      if (elOrigRow)  elOrigRow.style.display  = 'none';
      if (elDiscRow)  elDiscRow.style.display  = 'none';
      if (elUnitWrap) elUnitWrap.style.display = 'none';
      var inlineHide = document.getElementById('balmUnitPriceInline');
      if (inlineHide) inlineHide.style.display = 'none';
      return;
    }

    var qty           = state.qty;
    var discountCount = getDiscountCount(qty);
    var discountAmt   = discountCount * DISCOUNT_UNIT;
    var original      = UNIT_PRICE * qty;
    var total         = original - discountAmt;

    elTotal.innerHTML = formatYen(total);

    if (discountCount > 0) {
      if (elOrigRow)   elOrigRow.style.display  = '';
      if (elOrig)      elOrig.innerHTML           = formatYen(original);
      if (elDiscRow)   elDiscRow.style.display   = '';
      if (elDiscLabel) elDiscLabel.textContent   = discountCount + '回分割引';
      if (elDisc)      elDisc.innerHTML           = '−' + formatYen(discountAmt);
    } else {
      if (elOrigRow) elOrigRow.style.display = 'none';
      if (elDiscRow) elDiscRow.style.display = 'none';
    }

    if (elUnitWrap) elUnitWrap.style.display = '';
    if (elUnitVal)  elUnitVal.innerHTML       = formatYen(Math.floor(total / qty));

    /* インライン単価（数量カウンター横） */
    var inlineWrap    = document.getElementById('balmUnitPriceInline');
    var inlineBase    = document.getElementById('balmUnitPriceBase');
    var inlineActual  = document.getElementById('balmUnitPriceActual');
    var inlineActVal  = document.getElementById('balmUnitPriceActualValue');

    if (inlineWrap) {
      inlineWrap.style.display = '';
      if (inlineBase) inlineBase.innerHTML = '<span class="product-unit-price-value en">' + formatYen(UNIT_PRICE) + '</span> / 個';

      if (discountCount > 0 && inlineActual && inlineActVal) {
        var actualUnit = Math.floor(total / qty);
        inlineActVal.innerHTML = formatYen(actualUnit);
        inlineActual.style.display = '';
      } else if (inlineActual) {
        inlineActual.style.display = 'none';
      }
    }
  }

  /* ------------------------------------------------------------------
     STEP 4: カートボタン制御
  ------------------------------------------------------------------ */
  function renderCartState() {
    var btn  = document.getElementById('balmAddToCartBtn');
    var note = document.getElementById('balmCartNote');
    if (!btn) return;

    var remaining = getLimit() - getTotalScents();

    if (remaining === 0) {
      btn.disabled = false;
      if (note) note.textContent = '';
    } else {
      btn.disabled = true;
      if (note) note.textContent = '香りをあと' + remaining + '個選択してください';
    }
  }

  /* ------------------------------------------------------------------
     カートに追加
  ------------------------------------------------------------------ */
  function initAddToCart() {
    var btn       = document.getElementById('balmAddToCartBtn');
    var btnText   = btn && btn.querySelector('.balm-btn-text');
    var btnLoading = btn && btn.querySelector('.balm-btn-loading');
    if (!btn) return;

    btn.addEventListener('click', function () {
      if (btn.disabled) return;

      btn.disabled = true;
      if (btnText)    btnText.style.display    = 'none';
      if (btnLoading) btnLoading.style.display = '';

      if (state.purchaseType === 'subscription') {
        addSubscriptionToCart(btn, btnText, btnLoading);
      } else {
        addOnetimeToCart(btn, btnText, btnLoading);
      }
    });
  }

  function addSubscriptionToCart(btn, btnText, btnLoading) {
    // 最も多く選択された香りの定期購入専用バリアントIDを使用
    var topKey     = null;
    var maxCount   = 0;
    var properties = {};

    SCENT_KEYS.forEach(function (key) {
      var count = state.scentCounts[key] || 0;
      if (count === 0) return;
      properties[SCENT_CONFIG[key].label] = count + '個';
      if (count > maxCount) {
        maxCount = count;
        topKey   = key;
      }
    });

    var variantId = topKey ? SUB_VARIANT_MAP[topKey] : null;

    if (!variantId) {
      resetCartBtn(btn, btnText, btnLoading);
      alert('バリアントが見つかりません。');
      return;
    }

    fetchCartAdd({
      id: variantId,
      quantity: 1,
      selling_plan: MIKAWAYA_PLAN_ID,
      properties: properties
    }, btn, btnText, btnLoading);
  }

  function addOnetimeToCart(btn, btnText, btnLoading) {
    var variantId  = null;
    var properties = {};

    SCENT_KEYS.forEach(function (key) {
      var count = state.scentCounts[key] || 0;
      if (count === 0) return;
      var vKey = SCENT_CONFIG[key].variantKey;
      if (!variantId && window.BALM_VARIANTS) {
        variantId = window.BALM_VARIANTS[vKey];
      }
      properties[SCENT_CONFIG[key].label] = count + '個';
    });

    if (!variantId) {
      resetCartBtn(btn, btnText, btnLoading);
      alert('バリアントが見つかりません。');
      return;
    }

    fetchCartAdd(
      { id: variantId, quantity: state.qty, properties: properties },
      btn, btnText, btnLoading
    );
  }

  function fetchCartAdd(body, btn, btnText, btnLoading) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        alert('エラーが発生しました。もう一度お試しください。');
        resetCartBtn(btn, btnText, btnLoading);
      });
  }

  function resetCartBtn(btn, btnText, btnLoading) {
    btn.disabled = false;
    if (btnText)    btnText.style.display    = '';
    if (btnLoading) btnLoading.style.display = 'none';
  }

  /* ------------------------------------------------------------------
     初期化
  ------------------------------------------------------------------ */
  function init() {
    if (!window.balmPage) return;

    initPurchaseType();
    initQuantity();
    initScentGrid();
    initAddToCart();

    renderScentGrid();
    renderQtyPromo();
    renderQtyDiscountBanner();
    renderPrice();
    renderCartState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
